import { getApiClient } from './ApiClient'

// Read-only: the table is the qualityScoreUpdateAutomationV2 cron's output, recomputed weekly, so
// the API exposes no write route. The editable knob is the quality score boost page.
export const workoutResourceQualityScoreListPromise = (params) => {
  return getApiClient()
    .get('/workout-resource-quality-scores', { params })
    .then(resp => resp.data)
}
